<template>
  <v-flex xs12>
    <v-card flat color="transparent" class="rounded-bl rounded-br">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md4 pr-2 mb-2>
            <v-card color="white" class="rounded" elevation="1">
              <v-card-title>
                <h4 class="subheading pr-2">Ovations in</h4>
                <v-spacer></v-spacer>
                <v-flex style="flex-grow: 0" v-if="showFilter">
                  <v-select
                    height="24"
                    class="width-max-120px"
                    dense
                    outline
                    single-line
                    :items="yearList"
                    v-model="selectedYear"
                    label="Year"
                    @change="changeYear"
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex ml-1 style="flex-grow: 0" v-if="showFilter">
                  <v-select
                    height="24"
                    class="width-max-120px"
                    dense
                    outline
                    single-line
                    :items="monthList"
                    v-model="selectedMonth"
                    label="Month"
                    @change="changeMonth"
                    hide-details
                  ></v-select>
                </v-flex>
                <!-- <v-flex ml-2 style="flex-grow: 0">
                  <div
                    class="d-flex align-center filter-container"
                    @click.stop="showFilter = !showFilter"
                  >
                    <div>
                      <v-icon color="#d13b55" size="20">mdi-tune</v-icon>
                    </div>
                    <div class="text-main-theme ml-1">Filter</div>
                  </div>
                </v-flex> -->
                <!-- <v-flex text-xs-right>
                  <v-btn
                    icon
                    @click.stop="getOvationsByMonth()"
                    :disabled="doughnutLoading"
                  >
                    <v-icon title="Refresh" color="secondary"
                      >mdi-refresh</v-icon
                    >
                  </v-btn>
                </v-flex> -->
              </v-card-title>
              <v-card-text>
                <v-flex>
                  <v-progress-circular
                    v-if="doughnutLoading"
                    :size="32"
                    :width="4"
                    color="#d13b55"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
                <v-flex>
                  <DoughnutChart
                    v-if="!doughnutLoading"
                    :data="doughnutChartData"
                  ></DoughnutChart>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md4 pr-2 mb-2>
            <OvationsSummaryChart
              :ovations-summary-data="doughnutChartData"
              :year="selectedYear"
              :month="selectedMonth"
              :loading="doughnutLoading"
            ></OvationsSummaryChart>
          </v-flex>
          <v-flex xs12 md4 mb-2>
            <v-card color="white" class="rounded" elevation="1">
              <v-card-title>
                <h4 class="subheading">Ovations in recent months</h4>
                <!-- <v-flex text-xs-right>
                  <v-btn
                    icon
                    @click.stop="getOvationsByMonths()"
                    :disabled="ovationsLoading"
                  >
                    <v-icon title="Refresh" color="secondary"
                      >mdi-refresh</v-icon
                    >
                  </v-btn>
                </v-flex> -->
              </v-card-title>
              <v-card-text>
                <v-flex>
                  <v-progress-circular
                    v-if="ovationsLoading"
                    :size="32"
                    :width="4"
                    color="#d13b55"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
                <v-flex>
                  <OvationsBarChart
                    v-if="!ovationsLoading"
                    :data="ovationsBarChartData"
                  ></OvationsBarChart>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex>
            <v-card color="white" class="rounded" elevation="1">
              <v-card-title>
                <h4 class="subheading pr-4">Member Ovations</h4>
                <v-spacer></v-spacer>
                <v-flex md3>
                  <v-select
                    dense
                    outline
                    single-line
                    :items="$store.getters.getOrgList"
                    item-text="name"
                    item-value="subdomain"
                    v-model="selectedOrg"
                    label="Select Org"
                    @change="changeOrg"
                    hide-details
                  ></v-select>
                </v-flex>
                <!-- <v-flex text-xs-right>
                  <v-btn
                    icon
                    @click.stop="getOvationsByUsers()"
                    :disabled="userOvationsLoading"
                  >
                    <v-icon title="Refresh" color="secondary"
                      >mdi-refresh</v-icon
                    >
                  </v-btn>
                </v-flex> -->
              </v-card-title>
              <v-card-text>
                <v-flex>
                  <v-progress-circular
                    v-if="userOvationsLoading"
                    :size="32"
                    :width="4"
                    color="#d13b55"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
                <v-flex>
                  <UserOvationsBarChart
                    v-if="!userOvationsLoading"
                    :data="userOvationsBarChartData"
                  ></UserOvationsBarChart>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import DoughnutChart from "@/components/DoughnutChart";
import OvationsBarChart from "@/components/OvationsBarChart";
import UserOvationsBarChart from "@/components/UserOvationsBarChart";
import OvationsSummaryChart from "@/components/OvationsSummaryChart";

export default {
  name: "OvationAnalyticsView",
  components: {
    DoughnutChart,
    OvationsBarChart,
    UserOvationsBarChart,
    OvationsSummaryChart,
  },
  data() {
    return {
      showFilter: true,
      doughnutLoading: true,
      ovationsLoading: true,
      userOvationsLoading: true,
      doughnutChartData: {},
      ovationsBarChartData: [],
      userOvationsBarChartData: [],
      yearList: [
        (new Date().getFullYear() - 1).toString(),
        new Date().getFullYear().toString(),
      ],
      selectedYear: new Date().getFullYear().toString(),
      monthList: [
        { text: "---", value: "-1" },
        { text: "Jan", value: "1" },
        { text: "Feb", value: "2" },
        { text: "Mar", value: "3" },
        { text: "Apr", value: "4" },
        { text: "May", value: "5" },
        { text: "Jun", value: "6" },
        { text: "Jul", value: "7" },
        { text: "Aug", value: "8" },
        { text: "Sep", value: "9" },
        { text: "Oct", value: "10" },
        { text: "Nov", value: "11" },
        { text: "Dec", value: "12" },
      ],
      selectedMonth: (new Date().getMonth() + 1).toString(),
      doughnutStyles: {
        width: "100%",
        height: "296px",
        position: "relative",
      },
      barStyles: {
        width: "100%",
        height: "300px",
        position: "relative",
      },
      selectedOrg: this.$store.getters.getOrgIdentifier,
    };
  },
  methods: {
    getOvationsByMonth: function () {
      this.doughnutLoading = true;
      this.doughnutChartData = {};

      axios
        .get(
          "/api/org/analytics/ovationsbymonth/" +
            this.selectedYear +
            "/" +
            this.selectedMonth,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.doughnutChartData = response.data;
          this.doughnutLoading = false;
        })
        .catch((e) => {
          this.doughnutLoading = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Ovations by month.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });
        });
    },
    getOvationsByMonths: function () {
      this.ovationsLoading = true;
      this.ovationsBarChartData = [];

      axios
        .get(
          "/api/org/analytics/ovationsbymonths",
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.ovationsBarChartData = response.data;
          this.ovationsLoading = false;
        })
        .catch((e) => {
          this.ovationsLoading = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Ovations in recent months.<br>Response: " +
              e.response.data.message,
            messageType: "error",
          });
        });
    },
    getOvationsByUsers: function () {
      this.userOvationsLoading = true;
      this.userOvationsBarChartData = [];

      axios
        .get(
          "/api/user/analytics/ovationsbyusers/" + this.selectedOrg,
          this.$store.state.axiosConfig
        )
        .then((response) => {
          this.userOvationsBarChartData = response.data;
          this.userOvationsLoading = false;
        })
        .catch((e) => {
          this.userOvationsLoading = false;

          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error. Member Ovations.<br>Response: " + e.response.data.message,
            messageType: "error",
          });
        });
    },
    changeYear: function () {
      this.getOvationsByMonth();
    },
    changeMonth: function () {
      this.getOvationsByMonth();
    },
    changeOrg: function () {
      this.getOvationsByUsers();
    },
  },
  beforeMount() {
    this.getOvationsByMonth();
    this.getOvationsByMonths();
    this.getOvationsByUsers();
  },
};
</script>
